import type { CSSProperties } from 'react';

// Arte da capa/santo quando o dia não tem imagem: uma janela de capela em arco,
// desenhada em SVG — contorno fino dourado, brilho interno na cor litúrgica e
// uma pequena cruz de luz perto do alto. Visível em qualquer cor litúrgica.
export default function ArteSemImagem({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      viewBox="0 0 120 150"
      className={className}
      style={style}
      role="img"
      aria-label="Janela de capela em arco"
    >
      <defs>
        <radialGradient id="oracao-arco-brilho" cx="50%" cy="38%" r="62%">
          <stop offset="0%" stopColor="var(--fita)" stopOpacity="0.45" />
          <stop offset="100%" stopColor="var(--fita)" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="oracao-arco-vidro" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#000" stopOpacity="0.10" />
          <stop offset="100%" stopColor="#000" stopOpacity="0.35" />
        </linearGradient>
      </defs>

      {/* Janela em arco */}
      <path d="M14 138 V56 A46 46 0 0 1 106 56 V138 Z" fill="url(#oracao-arco-vidro)" />
      <path
        d="M14 138 V56 A46 46 0 0 1 106 56 V138 Z"
        fill="none"
        stroke="rgba(217,178,95,.45)"
        strokeWidth="1.4"
      />

      {/* Brilho interno */}
      <path d="M20 136 V56 A40 40 0 0 1 100 56 V136 Z" fill="url(#oracao-arco-brilho)" />

      {/* Cruz de luz */}
      <g stroke="var(--ouro-forte)" strokeWidth="1.6" strokeLinecap="round" opacity="0.9">
        <line x1="60" y1="42" x2="60" y2="66" />
        <line x1="49" y1="54" x2="71" y2="54" />
      </g>

      {/* Peitoril */}
      <line
        x1="6"
        y1="138"
        x2="114"
        y2="138"
        stroke="rgba(217,178,95,.4)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}